import React from 'react';
import doneIcon from '../../assets/images/done.svg';

const TournamentReportTab: React.FC = () => {
  return (
    <div className="bg-white p-4 border rounded-md leading-6">
      <div className="text-lg mb-4 border-b pb-2 font-medium">Bestätigung</div>
      <div className="flex gap-8 flex-wrap">
        <img
          src={doneIcon}
          alt="done"
          className="w-14 mt-4 sm:mt-0 mx-auto sm:mx-0"
        />
        Vielen Dank für Ihre Meldung. Die Meldebestätigung geht Ihnen direkt per E-Mail zu.
          <br />
          Gleichzeitig wurde die Bestätigung auch an den ausrichtenden Club und den Verband gesendet.
        <br />
      </div>
    </div>
  );
};

export default TournamentReportTab;
